import * as React from 'react'
import { logo, text } from './logo.module.scss'

function Logo(props) {
  return (
    <div className={logo}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={100}
        height={50}
        viewBox='0 0 200 50'
      >
        <g>
          <path d='M17.703 0l36.79 49.922 17.959-49.922z' fill='#e50019' />
          <path
            d='M38.061 27.623l12.939 1.79-15.129-20.568-2.536 12.365-15.635-21.21-17.7 50 54.494-.078z'
            fill='#004495'
          />
        </g>
        <g fill='#e50019'>
          <path d='M71.192 17.802h58.467s-1.427 7.95-10.683 10.767l-13.042 2.508 18.453 18.923h-20.149l-19.394-17.887-1.036.753-6.214 17.135h-18.077z' />
          <path d='M129.941 12.711h-56.867l4.614-12.71h42.9s8.848-.43 9.353 12.71z' />
        </g>
        <g fill='#004495'>
          <path d='M186.027 12.736h-47.266l4.623-12.739h53.775z' />
          <path d='M136.877 17.736h45.921l-14.131 13.868h-18.741l-6.731 18.4h-18.018z' />
        </g>
      </svg>
      <div className={`d-none d-sm-block ${text}`}>
        <p className='mb-0'>RubberFlooring4U</p>
        <p className='small mb-0'>Best prices Guaranteed!</p>
      </div>
    </div>
  )
}

export default Logo
